import { render, staticRenderFns } from "./divpage.vue?vue&type=template&id=ea61aa24&scoped=true&"
import script from "./divpage.vue?vue&type=script&lang=js&"
export * from "./divpage.vue?vue&type=script&lang=js&"
import style0 from "./divpage.vue?vue&type=style&index=0&id=ea61aa24&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea61aa24",
  null
  
)

export default component.exports